import type { ReactNode } from "react";

/** 图表面板：标题、说明、右侧的视图切换，下面是图例与图形（设计系统 Chart）。图形由页面用图表库画。 */
export function ChartPanel({ title, description, actions, legend, children }: { title: ReactNode; description?: ReactNode; actions?: ReactNode; legend?: ReactNode; children: ReactNode }) {
  return (
    <section className="ax-chart">
      <div className="ax-chart-head">
        <div>
          <h3 className="ax-chart-title">{title}</h3>
          {description && <p className="ax-chart-desc">{description}</p>}
        </div>
        {actions}
      </div>
      {legend}
      {children}
    </section>
  );
}

export interface LegendEntry { name: ReactNode; color: string }

/** 图例：每项一个色块加名称。只有一条序列时页面不放图例。 */
export function Legend({ items }: { items: LegendEntry[] }) {
  return (
    <div className="ax-legend">
      {items.map((it, i) => (
        <span key={i} className="ax-legend-item" style={{ color: it.color }}>
          <span className="ax-swatch" aria-hidden />
          <span className="ax-secondary">{it.name}</span>
        </span>
      ))}
    </div>
  );
}

export interface ChartTipRow { name: ReactNode; color: string; value: ReactNode }

/** 悬停提示框：第一行是北京时刻，下面每行是色块、名称与右对齐的数值，行的顺序由调用方排好（按数值从大到小）。 */
export function ChartTip({ time, rows }: { time: ReactNode; rows: ChartTipRow[] }) {
  return (
    <div className="ax-chart-tip">
      <div className="ax-chart-tip-time">{time}</div>
      {rows.map((r, i) => (
        <div key={i} className="ax-chart-tip-row">
          <span className="ax-swatch" style={{ color: r.color }} aria-hidden />
          {r.name}
          <span className="ax-num">{r.value}</span>
        </div>
      ))}
    </div>
  );
}
